import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Col,
  Input,
  FormFeedback,
  FormText,
  FormGroup,
  Label,
} from "reactstrap";

import userService from "../../services/userService";
import alertActions from "../../actions/alertActions";

const ResetPasswordModal = (props) => {
  const dispatch = useDispatch();
  const { buttonLabel } = props;
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(!modal);
    setFormState({
      email: "",
      submitted: false,
    });
  };
  const { register, handleSubmit, errors } = useForm();
  const [formState, setFormState] = useState({
    email: "",
    submitted: false,
  });

  const onChange = (evt) => {
    const { target } = evt;
    if (target) setFormState({ ...formState, [target.name]: target.value });
  };

  const onSubmit = (data) => {
    setFormState({ ...formState, submitted: true });
    userService.resetPasswordRequest(data).then(() => {
      dispatch(
        alertActions.success("Successfully sent password reset request.")
      );
    });
    return;
  };

  return (
    <div>
      <Button color="link" onClick={toggle}>
        {buttonLabel}
      </Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{buttonLabel}</ModalHeader>
        <ModalBody>
          <p className={formState.submitted ? "d-block" : "d-none"}>
            Thank you your request has been submitted.
          </p>
          <div className={!formState.submitted ? "d-block" : "d-none"}>
            <p>
              Enter your email or username. We'll email instructions on how to
              reset your password.
            </p>
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormGroup row>
                <Label sm={12}>E-mail</Label>
                <Col sm={12}>
                  <React.Fragment>
                    <Input
                      type="email"
                      name="email"
                      value={formState.email}
                      onChange={(evt) => onChange(evt)}
                      innerRef={register({
                        required: true,
                        min: 6,
                        pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        //pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      })}
                      invalid={errors.email ? true : false}
                    />
                    <FormText>Enter your email example@example.gov.</FormText>
                    {errors.email && (
                      <FormFeedback>Your email is not valid.</FormFeedback>
                    )}
                  </React.Fragment>
                </Col>
              </FormGroup>
              <Button
                type="submit"
                className="blueButton"
                style={{ width: "100%", marginBottom: "10px" }}
              >
                Submit
              </Button>
            </form>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ResetPasswordModal;
